import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import ProductCard from "../../Components/ProductCard";
import { fetchexclusive } from "../../api/products.api";
import './exclusive.css'
import { Routes, Route,useNavigate} from "react-router-dom";
const ExclusiveProducts = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [notAuthorized, setNotAuthorized] = useState(false);
  const navigate = useNavigate();
    useEffect(() => {
        let mounted = true;
        setLoading(true);
        fetchexclusive()
            .then((data) => {
                if (!mounted) return;
                setProducts(
                    Array.isArray(data?.results) ? data.results : []
                );
            })
            .catch((error) => {
                if (!mounted) return;

                if (error.status === 401 || error.status === 403) {
                    setNotAuthorized(true);
                }

            })

            .finally(() => {
                if (mounted) setLoading(false);
            });
        return () => {
            mounted = false;
        };
    }, [])


    if (loading) {
        return (
            <div className="search-page">
                <div className="loading-wrap">
                    <div className="loader" />
                    <p>Loading exclusive collection...</p>
                </div>
            </div>
        );
    }

    if (notAuthorized) {
        return (
            <div className="exclusive-locked">
                <div className="exclusive-locked-container">
                    <h2 onClick={() => navigate("/membership")}>
                        Unlock <span className="exclusive-highlight">Exclusive</span> Collection
                    </h2>
                    <p>
                        This collection is available only for active members.
                        Upgrade your membership to access premium products.
                    </p>

                    <button className="exclusive-upgrade-btn">
                        Upgrade Membership
                    </button>
                </div>
            </div>


        );
    }

    if (!loading && products.length === 0) {
        return (
            <div className="search-page">
                <p>No exclusive products available.</p>
            </div>
        );
    }

    return (
        <div className="search-page">
            <Helmet>
                <title>Event Exclusive Diecast Products | 164 Diecast Zone</title>
                <meta
                    name="description"
                    content="Shop event-exclusive 1:64 diecast model cars available only to 164 Diecast Zone members and event attendees."
                />
                <link rel="canonical" href="https://164diecastzone.com/event-exclusive" />
                <meta property="og:title" content="Event Exclusive Diecast Products | 164 Diecast Zone" />
                <meta property="og:url" content="https://164diecastzone.com/event-exclusive" />
            </Helmet>
            <div className="product-grid">
                {products.map((product) => (
                    <ProductCard
                        key={product.id}
                        product={product}
                    />
                ))}
            </div>
        </div>
    )

};
export default ExclusiveProducts;

